import { FastlyImage } from '@components/common/image'

const CareerGrowth = () => (
  <div className="px-5 py-12 lg:py-16 bg-white">
    <div className="container mx-auto flex flex-col items-center">
      <h2 className="pb-3 text-2xl text-center text-grey lg:text-4xl font-600">
        Career growth at Codingal
      </h2>
      <p className="text-lg text-grey mx-auto leading-tight text-center max-w-4xl">
        No matter which subject you teach, AI and Coding, Math, or English
        Language Arts, your career path follows the same structure with seven
        clear levels.
      </p>

      <div className="mt-10 w-full max-w-3xl mx-auto">
        <FastlyImage
          src="/images/teacher-lp/career-growth.png"
          alt="Career growth staircase at Codingal"
          width={900}
          height={840}
          className="w-full h-auto"
        />
      </div>
    </div>
  </div>
)

export default CareerGrowth
